const KEY = ['CONTENTS'];

const CONTENTS_JSON_KEY = [...KEY, 'JSON'];

export { KEY, CONTENTS_JSON_KEY };
